import React from "react";
import MainLayout from "../../components/layout";
import { Button, Card } from "antd";
import { LockOutlined } from "@ant-design/icons";
import "./styles.scss";

const SessionExpired = () => {
  return (
    <MainLayout>
      <Card className="session-expired-wrapper" role="region" aria-labelledby="session-expired-title">
        <div className="session-expired-inner">
          <div className="session-expired-icon" aria-hidden>
            <LockOutlined />
          </div>
          <h1 id="session-expired-title">You&apos;ve been signed out</h1>
          <p className="session-expired-lede">
            For your security, your session ended or you were logged out. Sign in again to pick up where
            you left off.
          </p>
          <Button
            type="primary"
            onClick={() => window.location.replace("/")}
            className="action-btn"
            block
          >
            Sign in
          </Button>
        </div>
      </Card>
    </MainLayout>
  );
};

export default SessionExpired;
